import { render, staticRenderFns } from "./AddNewTutor.vue?vue&type=template&id=03df1f5e&scoped=true"
import script from "./AddNewTutor.vue?vue&type=script&lang=js"
export * from "./AddNewTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df1f5e",
  null
  
)

export default component.exports